<template>
    <div>
      <patent-deadline-report></patent-deadline-report>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  
  